export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4 mb-6 sm:mb-8" data-testid={testid}>
      <div className="max-w-2xl min-w-0">
        <h1 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight text-neutral-900">{title}</h1>
        {subtitle && (
          <p className="text-neutral-600 mt-1.5 sm:mt-2 text-sm leading-relaxed">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
